import axios from "axios";
import Cookies from "js-cookie";

// DataVerse URLs
const DEV_URL = "https://agora-recruitment.crm8.dynamics.com";
const PROD_URL = "https://talenthub.crm8.dynamics.com";

const currentOrigin = window.location.origin;
const RESOURCE_URL =
  currentOrigin === "https://talenthub.intelegain.com" ? PROD_URL : DEV_URL;

const axiosInstance = axios.create({
  baseURL: RESOURCE_URL + `/api/data/v9.2`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor to handle 401 and redirect to /login
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isCandidateFeedbackPage =
        window.location.pathname.startsWith("/candidatefeedback/") ||
        window.location.pathname.startsWith("/candidate-form/");

      if (!isCandidateFeedbackPage) {
        Cookies.remove("token"); // Remove token from cookies
        window.location.href = "/login"; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
